import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.handleBackdropClick.bind(this))
    document.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  open() {
    this.element.showModal()
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.element.close()
    document.body.classList.remove('overflow-hidden')
  }

  handleBackdropClick(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.element.open) {
      this.close()
    }
  }
}
